// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__3jkWc","none":"Content_none__1dq2i","singleColumn":"Content_singleColumn__1VrIk","twentyFourColumns":"Content_twentyFourColumns__4QOuN"};